import React from 'react';
import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';
import moment from 'moment';
import { getConstant } from '../../../../utils/constants';
import styles from "../../cards.module.scss"

function EventItem({ event, handleClickEvent, layout }) {
  return (
    <div
      className={`${styles.projectCard} ${layout === "grid" ? styles.projectCardGrid : ''}`}
      onClick={handleClickEvent}>
      <img
        className={styles.projectImage}
        src={event.main_image ? event.main_image.file : getImage('img-ph.png')}
        alt={event.main_image ? event.main_image.label : 'Non renseignée'}
      />
      <div className={styles.contentContainer}>
        <div className={styles.topInfo}>
          <p className={styles.title}>{event.title}</p>
          <span className={styles.subtitle}>
            {moment(event.start_dt).format('ll')}
            {" - "}{moment(event.end_dt).format('ll')}</span>
        </div>
        <div className={styles.tagList}>
          <Tag
            tag={{
              label: getConstant('kerbouzier.types', event.type).label,
              bgColor: getConstant('kerbouzier.types', event.type).bgColor
            }}
          />
          <Tag
            tag={{
              label: getConstant('kerbouzier.subtypes', event.subtype).label,
              bgColor: getConstant('kerbouzier.subtypes', event.subtype).bgColor
            }}
          />
        </div>
      </div>
    </div >
  );
}

export default EventItem;
